/* eslint-disable */
import React from "react";
import { useDictionary, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { uniqBy, first } from "lodash";
import { HierarchyControl, HierarchyControlItem } from "../../../../basf-ui";
import { equal } from "../../../../../shared";

interface ControlItem extends HierarchyControlItem<number> {}

export const UnitsControl: React.FC = () => {
  const [controlItems, setControlItems] = React.useState<ControlItem[]>([]);

  const [units, setUnitValue] = useParameter<number[]>("@units");
  const [commodityValue] = useParameter<number[] | null>("@commodities");
  const [selectedUnitId, selectUnitId] = useParameter<number>("@selected_unit_id");
  const [unitDictItems, , loading] = useDictionary(dictionaryService, "f_units_ap_official_prices", undefined, {
    p_commodities: commodityValue?.join(","),
  });

  React.useEffect(
    function updateControlItems() {
      if (unitDictItems) {
        const uniqueDictItems = uniqBy(unitDictItems, (item) => item.getValue<number>("id"));
        const nextControlItems = uniqueDictItems.map<ControlItem>((dictItem) => ({
          id: Number(dictItem.id),
          name: (dictItem.getValue("name") as any)[9] as string,
        }));
        setControlItems(nextControlItems);

        let selectedItems = nextControlItems.filter((item) => units?.includes(item.id)).map((item) => item.id);
        if (selectedItems === undefined && nextControlItems[0]) {
          setUnitValue(selectedItems);
        }
      }
    },
    [unitDictItems],
  );

  React.useEffect(
    function updateUnitValueWhenAvailableUnitsChange() {
      if (unitDictItems != null) {
        const unitsAvailableForCurrentCommoditySelection = units?.filter(
          (unit) => unitDictItems.find((unitDictItem) => unitDictItem.getValue<number>("id") === unit) != null,
        );

        const isUnitsEqual = equal(units, unitsAvailableForCurrentCommoditySelection);

        if (!isUnitsEqual) {
          if (
            unitsAvailableForCurrentCommoditySelection != null &&
            unitsAvailableForCurrentCommoditySelection.length > 0
          ) {
            setUnitValue(unitsAvailableForCurrentCommoditySelection);
          } else {
            const uniqUnits = uniqBy(unitDictItems, (item) => item.getValue<number>("id"));
            const firstAvailableUnit = first(uniqUnits);

            if (firstAvailableUnit != null) {
              const unitId = Number(firstAvailableUnit.getValue("id"));

              setUnitValue([unitId]);
              selectUnitId(unitId);
            }
          }
        }
      }
    },
    [units, unitDictItems],
  );

  const handlerChange = React.useCallback(
    (selectedIds: number[] | undefined | null) => {
      if (selectedIds != null) {
        if (selectedIds?.length > 0 && !equal(units, selectedIds)) {
          setUnitValue(selectedIds);
        }

        if (selectedUnitId != null && !selectedIds.includes(selectedUnitId)) {
          const unitCandidate = first(selectedIds);
          selectUnitId(Number(unitCandidate));
        }
      }
    },
    [units, selectedUnitId],
  );

  return (
    <HierarchyControl
      multiple
      loading={loading}
      label="Unit"
      value={units!}
      onChange={handlerChange}
      items={controlItems}
    />
  );
};
